// A card face says each thing once. The "why it's here" line sits under the title; a plain text
// summary block that only repeats it is left out (cards often carry the same sentence in both).
import type { CardBlock } from "@shared/core";

/** True when two lines say the same, ignoring spacing, case and trailing punctuation. */
export function sameSentence(a: string | null | undefined, b: string | null | undefined): boolean {
  if (!a || !b) return false;
  const key = (s: string) =>
    s
      .replace(/\s+/g, " ")
      .trim()
      .replace(/[\s.!?…:;,]+$/u, "")
      .toLowerCase();
  const ka = key(a);
  return ka !== "" && ka === key(b);
}

/** The blocks to show under `why`, minus a plain summary (no title of its own) that repeats it. */
export function blocksBesideWhy(why: string, blocks: readonly CardBlock[]): CardBlock[] {
  return blocks.filter((b) => !(b.type === "rich_text" && !b.title && sameSentence(b.text, why)));
}
